const fonts = {
  fontFamily: {
    headings: '"Quicksand", sans-serif',
    body: '"Roboto", sans-serif;'
  },
};

export default fonts;
